import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'

export default ({ path }) => {
    return (
        <div className={baseStyles.root}>
            <h2>Rentrée et calendrier académique</h2>
            <PageStatus path={path} />
            <p>
                Rentrée académique le <strong>14 septembre 2026</strong>
            </p>
            <p>
                Prenez attention au{' '}
                <a
                    href="https://intra.heig-vd.ch/academique/calendriers-academiques/Pages/calendriers-academiques.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    calendrier académique
                </a>{' '}
                de l'École qui vous permettra d’organiser vos activités et loisirs en fonction des semaines de cours et
                d’examens.
            </p>
        </div>
    )
}
